import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  fetchMerchant,
  fetchMembershipProgram,
} from "../../actions/merchantActions";
import { languages } from "../../helpers/language";
import MembershipPlan from "./MembershipPlan";

const MembershipProgramSection = ({
  merchantData,
  appStateData,
  fetchMembershipProgram,
}) => {
  let { shopDomain } = appStateData;
  let { merchant, membershipProgram } = merchantData;

  const details = {
    membership_program_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.membership_program_title"
      ],
    membership_program_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.membership_program_desc"
      ],
    no_membership_plans:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.no_membership_plans"
      ],
    membership_program_note:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.membership_program_note"
      ],
  };

  useEffect(() => {
    fetchMembershipProgram(shopDomain);
  }, []);

  return (
    <div className="membershipProgram-section-wrapper">
      <div className="membershipProgram-heading-container">
        <h2 className="membershipProgram-heading">
          {details.membership_program_title}
        </h2>
        <p className="membershipProgram-desc">
          {details.membership_program_desc}
        </p>
        <p className="membershipProgram-note">
          {"*" + details.membership_program_note}
        </p>
        <h3 className="membershipProgram-name">{membershipProgram?.name}</h3>
      </div>
      <div className="membershipProgram-items-wrapper">
        {Array.isArray(membershipProgram?.plans) &&
        membershipProgram?.plans?.length > 0 ? (
          membershipProgram?.plans.map((plan, i) => (
            <MembershipPlan key={i} plan={plan} />
          ))
        ) : (
          <span className="membershipProgram-noPlan">
            {details.no_membership_plans}
          </span>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  merchantData: state.MerchantReducer,
  appStateData: state.AppstateReducer,
  customerData: state.CustomerReducer,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMerchant: (shopDomain) => dispatch(fetchMerchant(shopDomain)),
  fetchMembershipProgram: (shopDomain) =>
    dispatch(fetchMembershipProgram(shopDomain)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembershipProgramSection);
